const PLUGIN_NAME = 'page-builder-fe';

export { PLUGIN_NAME };
